import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import UIButton from 'UIComponents/button/UIButton';
import UITooltip from 'UIComponents/tooltip/UITooltip';
import { ButtonText, GoogleSignInDiv, ImageWrapper } from './GoogleLoginButton.styles';
import UIImage from 'UIComponents/image/UIImage'; // @ts-expect-error not converted to TS

import Images from '../../images/imageUrls';
import FormattedMessage from 'I18n/components/FormattedMessage';

const isIframed = () => {
  try {
    return window.self !== window.top;
  } catch (e) {
    return false;
  }
};

const GoogleLoginButton = ({
  onClick,
  smartLogin,
  disabled,
  tooltipDisabled = true
}) => {
  return /*#__PURE__*/_jsx(UITooltip, {
    title: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "login.smartLogin.disabledButtonHelp"
    }),
    disabled: tooltipDisabled,
    children: /*#__PURE__*/_jsx(UIButton, {
      "data-test-id": "google-sign-in",
      onClick: onClick,
      target: isIframed() ? '_blank' : '_self',
      use: "unstyled",
      className: "width-100",
      disabled: disabled,
      children: /*#__PURE__*/_jsxs(GoogleSignInDiv, {
        smartLogin: smartLogin,
        disabled: disabled,
        children: [/*#__PURE__*/_jsx(ImageWrapper, {
          smartLogin: smartLogin,
          disabled: disabled,
          children: /*#__PURE__*/_jsx(UIImage, {
            height: 22,
            width: 22,
            src: Images.googleLogo
          })
        }), /*#__PURE__*/_jsx(ButtonText, {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "login.form.connected"
          })
        })]
      })
    })
  });
};

export default GoogleLoginButton;